import { container } from "../footer/";

export const footer = document.createElement("footer");

footer.setAttribute("id", "contacts");

footer.append(container);
